import { motion } from 'framer-motion';
import { Container, Grid, Stack, Typography } from '@mui/material';
import { MotionInView, varFadeInRight, varFadeInUp } from '../../animate';
import { Breakpoint } from '@mui/system/createTheme/createBreakpoints';
import { styled, SxProps } from '@mui/system';
import { MotionViewFadeUp } from '../../MotionViewFadeUp';

export interface LandingIconsTitleProps {
  title?: string;
  icons: string[];
  maxWidth?: Breakpoint;
  sx?: SxProps;
}

const RootStyle = styled('div')();

const ImgMotion = styled(motion.img)(() => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'block'
}));

export default function LandingIconsTitle({ icons, title, maxWidth, sx }: LandingIconsTitleProps) {
  return (
    <RootStyle sx={sx}>
      <Container maxWidth={maxWidth ? maxWidth : 'lg'}>
        <Stack>
          <MotionViewFadeUp>
            {title && (
              <>
                <Typography
                  sx={{
                    textAlign: 'center',
                    margin: '1em 0 2.5em 0',
                    display: {
                      xl: 'block',
                      lg: 'block',
                      md: 'block',
                      sm: 'none',
                      xs: 'none'
                    }
                  }}
                  variant={'h2'}
                >
                  {title}
                </Typography>
                <Typography
                  sx={{
                    textAlign: 'center',
                    margin: '1em 0 2.5em 0',
                    display: {
                      xl: 'none',
                      lg: 'none',
                      md: 'none',
                      sm: 'block',
                      xs: 'block'
                    }
                  }}
                  variant={'h4'}
                >
                  {title}
                </Typography>
              </>
            )}
          </MotionViewFadeUp>

          <MotionInView variants={varFadeInUp}>
            <Grid container mb={'3em'} justifyContent="center">
              {icons.map((icon, index) => (
                <Grid key={index} item xs={6} sm={6} md={3} lg={2} xl={2}>
                  <ImgMotion variants={varFadeInRight} src={icon} alt={icon} />
                </Grid>
              ))}
            </Grid>
          </MotionInView>
        </Stack>
      </Container>
    </RootStyle>
  );
}
